import { Link, useLocation } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import ICDash from "@/components/Icon/ICNavbar/ICDash";
import ICVault from "@/components/Icon/ICNavbar/ICVault";
import ICRank from "@/components/Icon/ICNavbar/ICRank.tsx";
import { cn } from "@/utils/utils";
import { usePrivy } from "@privy-io/react-auth";

const HEADER_ROUTES = [
  {
    path: "/dashboard",
    label: "navbar.dashboard",
    icon: <ICDash width="24" height="24" />,
  },
  {
    path: "/ranking",
    label: "navbar.ranks",
    icon: <ICRank width="24" height="24" />,
  },
  {
    path: "/user-profile",
    label: "navbar.menu.profile",
    icon: <ICVault width="24" height="24" />,
  }
];

export default function DesktopNavigation() {
  const { t } = useTranslation();
  // See the current pathname use `useLocation` from `@tanstack/react-router`
  const { pathname } = useLocation();
  const { user } = usePrivy();

  // Helper function to determine if a link is active
  const isActive = (path: string) => pathname === path;
  const isVerifyPath = pathname === "/verify" || pathname === "/not-found";

  return (
    <nav className="absolute left-1/2 transform -translate-x-1/2 lg:flex space-x-4 lg:items-center lg:justify-center hidden">
      {HEADER_ROUTES.map((route) => {
        // Determine if this route should be disabled
        const isProfileRoute = route.path === "/user-profile";
        const isRouteDisabled = (isProfileRoute && !user) || isVerifyPath;
        
        return (
          <Link
            key={route.path}
            to={route.path}
            className={cn(
              "flex gap-2 p-2 transition-colors text-gray-400 hover:text-white font-semibold",
              {
                "text-white": isActive(route.path),
                "cursor-not-allowed opacity-50": isRouteDisabled,
              }
            )}
            onClick={isRouteDisabled ? (e) => e.preventDefault() : undefined}
            title={isProfileRoute && !user ? "Please login first" : undefined}
          >
            {route.icon}
            {t(route.label)}
          </Link>
        );
      })}
    </nav>
  );
}
